import styled from 'styled-components'
import { accents } from 'sutra/tokens/colors'

export const CollapsedShell = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fcfafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 8px;
  cursor: pointer;
`

export const Shell = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fcfafa;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 280px;
`

export const PanelSwitcherRow = styled.div`
  padding: 12px 16px 0;
  flex-shrink: 0;
`

export const ScrollArea = styled.div`
  padding: 12px 16px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  opacity: 1;
  transition: opacity 0.2s ease-out;
`

export const SectionsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ChartSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;
`

export const HeaderTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const HeaderTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
`

// Groups a header-row sync toggle with the collapse button.
export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

// Portal target for the filter section's add-filter (and sync) buttons when
// 'filter' is the sidebar's only section (Feedback) — lets those buttons sit
// in the main header row, left of the collapse button, instead of the filter
// section rendering its own duplicate "Filter" heading below.
export const FilterHeaderActionsSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const PANEL_SWITCHER_COLORS = {
  pressedBg: accents.reflectionBlue[100],
  pressedHoverBg: accents.reflectionBlue[100],
  pressedColor: '#1f2937',
  unpressedBg: '#ffffff',
  unpressedHoverBg: '#5072a426',
  unpressedColor: '#1f2937',
  borderColor: '#e5e7eb',
  containerBorder: '1px solid #d1d5db',
}
